export enum PaymentMethods {
  Wire = 'WIRE',
  Card = 'CARD',
  Affirm = 'AFFIRM',
  Klarna = 'KLARNA',
  Bitpay = 'BITPAY'
}
